
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/we-chat",
      function () {
        return require("private-next-pages/we-chat/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/we-chat"])
      });
    }
  